import { useNavigate } from "react-router-dom"

import { SEX_LABELS, SLOT_TYPE_LABELS } from "./constants"
import style from "./style.module.scss"

import { Psychologist, Sex, SlotType } from "utils/interfaces"
import { Button, Img, Text } from "ui-kit/components-branded/index"

interface CompetencesProps {
    profiles: Psychologist[]
    title: string
    sex?: Sex
    formOfWork?: SlotType
    priceMin: number | undefined
    priceMax: number | undefined
    priceCategory?: string
    slug: string
    competences: string
}

export function Competences({
    profiles,
    title,
    sex,
    formOfWork,
    priceMin,
    priceMax,
    priceCategory,
    slug,
    competences,
}: CompetencesProps) {
    const navigate = useNavigate()

    if (profiles.length == 0 && !competences) {
        return null
    }

    const handleClickButton = () => {
        navigate("/survey/psy", {
            replace: true,
            state: {
                slug: slug,
            },
        })
    }

    const showPrice = priceCategory || priceMin || priceMax

    return (
        <>
            <div className={style.header}>
                <Img src="search.png" className={style.emoji} />
                <Text isAccent>Параметры вашего поиска</Text>
            </div>
            <div className={style.requests}>
                <Text className={style.requestItem}>{title}</Text>
                {formOfWork && (
                    <Text className={style.requestItem}>
                        Формат терапии: {SLOT_TYPE_LABELS[formOfWork]}
                    </Text>
                )}
                {sex && <Text className={style.requestItem}>Пол психолога: {SEX_LABELS[sex]}</Text>}
                {!!showPrice && (
                    <Text className={style.requestItem}>
                        Стоимость сессии:&nbsp;
                        {priceCategory == "any" ? (
                            "цена не важна"
                        ) : (
                            <>
                                {priceMin && priceMax && `${priceMin}–${priceMax} ₽`}
                                {priceMin && !priceMax && `от ${priceMin} ₽`}
                                {!priceMin && priceMax && `до ${priceMax} ₽`}
                            </>
                        )}
                    </Text>
                )}
            </div>
            {competences && (
                <>
                    <div className={style.competencesHeader}>
                        <Img src="table.png" className={style.competenceEmoji} />
                        <Text isAccent>Ваши запросы</Text>
                    </div>
                    <div className={style.requests}>
                        {competences.split("% ").map((item) => {
                            return (
                                <Text className={style.requestItem} key={item}>
                                    {item}
                                </Text>
                            )
                        })}
                    </div>
                </>
            )}
            <Button className={style.button} onClick={handleClickButton}>
                Изменить параметры
            </Button>
        </>
    )
}
